var swiper = new Swiper ('.tablet-slider', {
    slidesPerView: 2,
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    autoplay: {
       delay: 1750,
    },
    speed: 650,
    // Responsive breakpoints
    breakpoints: {
        1200: {
            slidesPerView: 4,
        },
        960: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 2,
        },
    },
});

var phoneSwiper = new Swiper ('.phone-slider', {
    slidesPerView: 2,
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    autoplay: {
       delay: 1500,
    },
    speed: 650,
    breakpoints: {
        1200: {
            slidesPerView: 4.5,
        },
        960: {
            slidesPerView: 3,
        },
        768: {
            slidesPerView: 2.5,
        },
    },
});

// var swiper = new Swiper ('.other-services-swiper', {
//     observer: true,
//     observeParents: true,
//     slidesPerView: 4,
//     spaceBetween: 30,
//     centeredSlides: false,
// //     loop: true,
//     autoplay: true,
//     autoplay: {
//        delay: 1500,
//     },
//     speed: 650,
//     breakpoints: {
//         1200: {
//             slidesPerView: 4,
//         },
//         960: {
//             slidesPerView: 3,
//         },
//         768: {
//             slidesPerView: 2,
//         },
//         497: {
//             slidesPerView: 1,
//         },
//     },
//     navigation: {
//         nextEl: '.other-services-next',
//         prevEl: '.other-services-prev',
//     },
// });

var otherServicesSwiper = new Swiper ('.other-services-swiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    centeredSlides: false,
    loop: false,
    autoplay: {
       delay: 1500,
    },
    speed: 650,
    breakpoints: {
        1200: {
            slidesPerView: 3,
            autoplay: false
        },
        768: {
            slidesPerView: 2,
        },
    },
    navigation: {
        nextEl: '.other-services-next',
        prevEl: '.other-services-prev',
    },
});

var otherServicesSwiper = new Swiper ('.related-blog', {
    slidesPerView: 4,
    spaceBetween: 30,
    centeredSlides: false,
    loop: true,
    autoplay: {
       delay: 1500,
    },
    speed: 650,
    breakpoints: {
        1200: {
            slidesPerView: 4,
        },
        960: {
            slidesPerView: 3,
        },
        768: {
            slidesPerView: 2,
        },
        0: {
            slidesPerView: 1,
        },
    },
    navigation: {
        nextEl: '.blog-next-btn',
        prevEl: '.blog-prev-btn',
    },
});

var montageSwiper = new Swiper ('.montage-slider', {
    slidesPerView: 2,
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    autoplay: {
       delay: 1750,
    },
    speed: 650,
    // Responsive breakpoints
    breakpoints: {
        1200: {
            slidesPerView: 1.75,
        },
        960: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 2,
        },
    },
});

var featuredCaseStudySwiper = new Swiper ('.featured-case-study-wrapper', {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true,
    speed: 650,
    autoplay: {
       delay: 3750,
    },
    breakpoints: {
        1200: {
            slidesPerView: 2,
        },
        960: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 1,
        },
        0: {
            slidesPerView: 1,
        },
    },
});

var logoSwiper = new Swiper ('.logo-swiper', {
    loop: true,
    autoplay: {
        delay: 0,
    },
    slidesPerView: 'auto',
    spaceBetween: 0,
    speed: 3000,
    disableOnInteraction: false,
    mousewheelControl: true,
    keyboardControl: true,
    preventInteractionOnTransition: true,
});
